var map = {
	"./EmptyBoxContainer": [
		27388,
		"EmptyBoxContainer"
	],
	"./EmptyBoxContainer.tsx": [
		27388,
		"EmptyBoxContainer"
	],
	"./WidgetContainer": [
		98478,
		"WidgetContainer"
	],
	"./WidgetContainer.tsx": [
		98478,
		"WidgetContainer"
	],
	"./WidgetFooter": [
		44794,
		"WidgetFooter"
	],
	"./WidgetFooter.tsx": [
		44794,
		"WidgetFooter"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1465;
module.exports = webpackAsyncContext;